<template>
    <div style="overflow:hidden;width:1585px;margin-left:150px">
      <iframe :src="url" frameborder="0" width="1600"  class="frame" id="iframepage" @load="changeFrameHeight"></iframe>
    </div>
</template>

<script>
export default {
  data () {
    return {
      url: ''
    }
  },
  created () {
    this.detail()
  },
  methods: {
    detail () {
      let self = this
      self.url =
        '/api/zhaopin/zhiwei/jianli/view?i=' + sessionStorage.getItem('jianli')
    },
    changeFrameHeight () {
      var ifm = document.getElementById('iframepage')
      ifm.height = document.documentElement.clientHeight
    }
  }
}
</script>
